import moment from 'moment';

const breakdown = {
	scheduled: [],
	rescheduled: [],
	completed: [],
	cancelled: [],
	sales: [],
	accepted: [],
	quotes: [],
};

Vue.component('client-reports', {
	data () {
		return {
			loading: false,
			data: {
				stats: {
					all: 0,
					scheduled: 0,
					rescheduled: 0,
					completed: 0,
					cancelled: 0,
					sales: 0,
					hotLeads: 0,
					activeLeads: 0,
					quotes: 0,
				},

				breakdown,

				plusvibeStats: null,
			},
			managedSales: false,
			reportHotLeads: false,
            reportDeadLeads: false,
			reportActiveLeads: false,
			usesQuotes: false,
			fullSales: false,
            clientExport: false,
		};
	},

	mounted () {
		this.fetchReport();

		Bus.$on('updated-feedback', (apt) => {
			const i = this.data.breakdown[apt.quote_status].map(a => a.id).indexOf(apt.id);

			this.data.breakdown[apt.quote_status][i].client_feedback = apt.client_feedback;
		});
	},

	methods: {
		fetchReport () {
			this.loading = true;

			axios.get('/api/client-report')
				.then((response) => {
					this.loading = false;
					this.managedSales = response.data.managed_sales;
					this.reportHotLeads = response.data.report_hot_leads;
					this.reportDeadLeads = response.data.report_dead_leads;
					this.reportActiveLeads = response.data.report_active_leads;
					this.clientExport = response.data.client_export;
					this.fullSales = response.data.full_sales;
					this.usesQuotes = response.data.uses_quotes;

					this.data.plusvibeStats = response.data.plusvibe_stats;

					this.data.breakdown = breakdown;

					response.data.leads.forEach(lead => {
						this.data.breakdown[lead.quote_status].push(lead);
					});

					if (this.reportHotLeads) {
						this.data.breakdown['hot_leads'] = response.data.hot_leads;
					}

					if (this.reportActiveLeads) {
						this.data.breakdown['accepted'] = response.data.active_leads;
					}

					this.data.breakdown['dead_leads'] = response.data.dead_leads;

					if (this.usesQuotes) {
						this.data.breakdown['quotes'] = response.data.quotes;
					}

					this.data.stats = {
						all: response.data.leads.length,
						scheduled: this.data.breakdown.scheduled ? this.data.breakdown.scheduled.length : 0,
						rescheduled: this.data.breakdown.rescheduled ? this.data.breakdown.rescheduled.length : 0,
						completed: this.data.breakdown.completed ? this.data.breakdown.completed.length : 0,
						cancelled: this.data.breakdown.cancelled ? this.data.breakdown.cancelled.length : 0,
						sales: this.data.breakdown.sales ? this.data.breakdown.sales.length : 0,
						hotLeads: this.data.breakdown.hot_leads ? this.data.breakdown.hot_leads.length : 0,
						deadLeads: this.data.breakdown.dead_leads ? this.data.breakdown.dead_leads.length : 0,
						activeLeads: this.data.breakdown.accepted ? this.data.breakdown.accepted.length : 0,
						quotes: this.data.breakdown.quotes ? this.data.breakdown.quotes.length : 0,
					};
				});
		},

		loadData (appointment) {
			this.appointment = appointment;
			this.loading = true;
		},

		exportLeads () {
			this.loading = true;

			axios.get('/api/client-report/export')
				.then((response) => {
					const fileURL = window.URL.createObjectURL(new Blob([response.data]));
		            const fileLink = document.createElement('a');
		            const filename = 'leads-report.xlsx';

		            fileLink.href = fileURL;
		            fileLink.setAttribute('download', filename);
		            document.body.appendChild(fileLink);

		            fileLink.click();

		            this.loading = false;
				});
		}
	}
});

Vue.component('client-reports-table', {
	props: ['header', 'data', 'mode'],

	data () {
		return {
			appointment: false,

            feedbackForm: $.extend(true, new Form({
                data: {
                    feedback: ''
                }
            }), {})
		};
	},

	methods: {
		viewMoreInformation (appointment) {
			this.appointment = appointment;
			this.feedbackForm.data.feedback = appointment.client_feedback;

			$(this.$refs['more-info']).modal('show');
		},

		submitFeedback () {
			Http.post(`/api/client-report/feedback/${this.appointment.id}`, this.feedbackForm).then(() => {
				Bus.$emit('updated-feedback', {
					id: this.appointment.id,
					quote_status: this.appointment.quote_status,
					client_feedback: this.feedbackForm.data.feedback
				});
			});
		}
	},

	template: `
		<div>
			<div class="row">
				<div class="col">
					<h4>{{this.header}}</h4>
				</div>
			</div>

			<div class="row">
				<div class="col">
					<div class="card mb-5">
						<div class="card-body">
							<table class="table table-appointments">
								<thead>
									<tr>
										<th width="10%">ID#</th>
										<th width="50%" v-if="mode === 'appointments'">Appointment Details</th>
										<th width="50%" v-if="mode === 'hot-leads'">Lead Details</th>
										<th width="10%">More Info</th>
										<th width="15%">Status</th>
										<th width="15%">Progress</th>
									</tr>
								</thead>

								<tbody v-if="!this.data || this.data.length === 0">
									<tr>
										<td colspan="5" class="text-center">
											There is nothing to show you
										</td>
									</tr>
								</tbody>

								<tbody v-if="this.data && this.data.length > 0">
									<tr v-for="row in this.data">
										<td>{{ row.quote_id }}</td>
										<td>
											{{(row.contact_name ?? row.quote_contact_name) + (row.company ? ' at ' + row.company : '') + (row.lead_contact_company ? ' at ' + row.lead_contact_company : '')}} <br />
											{{ row.type === 'appointment' ? row.date_of_appointment_clean : '' }}
										</td>
										<td>
											<div class="cursor-pointer" @click="viewMoreInformation(row)">
												<i class="fas fa-external-link-alt"></i>
											</div>
										</td>
										<td>{{ mode === 'hot-leads' ? (header == 'Hot Leads' ? 'Hot' : (header === 'Active Leads' ? 'Active' : 'Dead')) : row.status }}</td>
										<td>
											<div class="progress" style="height: 3px;">
  												<div class="progress-bar" :class="{
                                                  'bg-success': mode === 'appointments' && row.quote_status === 'completed' || mode === 'appointments' && row.quote_status === 'sales', 
                                                  'bg-danger': mode === 'appointments' && row.quote_status === 'cancelled' || mode === 'hot-leads', 
                                                  'bg-warning': mode === 'appointments' && row.quote_status === 'scheduled',
                                                  'bg-warning-2': mode === 'appointments' && row.quote_status === 'rescheduled'
                                                }" style="width: 100%"></div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>

					<div class="modal fade" ref="more-info">
						<div class="modal-dialog modal-lg">
							<div class="modal-content">
								<div class="modal-header">
									<h5 class="modal-title"></h5>
									<button type="button" class="close" data-dismiss="modal" aria-label="Close">
										<span aria-hidden="true">&times;</span>
									</button>
								</div>

								<div class="modal-body" v-if="this.appointment">
									<div class="row">
										<div class="col">
											<p>
												<strong>Company</strong><br />
												{{ this.appointment.company ?? 'N/A' }}
											</p>
										</div>
										<div class="col">
											<p>
												<strong>Contact Name</strong><br />
												{{ this.appointment.contact_name ?? 'N/A' }}
											</p>
										</div>
										<div class="col">
											<p>
												<strong>Job Title</strong><br />
												{{ this.appointment.job_title ?? 'N/A' }}
											</p>
										</div>
									</div>

									<div class="row">
										<div class="col">
											<p>
												<strong>Email Address</strong><br />
												
												<a :href="'mailto:' + this.appointment.email" v-if="this.appointment.email">{{ this.appointment.email }}</a>
												<span v-if="!this.appointment.email">N/A</span>
											</p>
										</div>

										<div class="col">
											<p>
												<strong>Telephone</strong><br />
												{{ this.appointment.telephone ?? 'N/A' }}
											</p>
										</div>

										<div class="col">
											<p>
												<strong>Mobile</strong><br />
												{{ this.appointment.mobile ?? 'N/A' }}
											</p>
										</div>
									</div>

									<div class="row">
										<div class="col">
											<p>
												<strong>Employees</strong><br />
												{{ this.appointment.employees ?? 'N/A' }}
											</p>
										</div>

										<div class="col">
											<p>
												<strong>Turnover</strong><br />
												{{ this.appointment.turnover ?? 'N/A' }}
											</p>
										</div>

										<div class="col">
											<p>
												<strong>Lead Source</strong><br />
												{{ this.appointment.lead_source ?? 'N/A' }}
											</p>
										</div>
									</div>

									<div class="row">
										<div class="col">
											<p>
												<strong>Industry</strong><br />
												{{ this.appointment.contact_industry?.length > 0 ? this.appointment.contact_industry : 'N/A' }}
											</p>
										</div>

										<div class="col">
											<p>
												<strong>Country</strong><br />
                                              {{ this.appointment.contact_country?.length > 0 ? this.appointment.contact_country : 'N/A' }}
											</p>
										</div>

										<div class="col">
											<p>
												<strong>Region</strong><br />
                                              {{ this.appointment.contact_region?.length > 0 ? this.appointment.contact_region : 'N/A' }}
											</p>
										</div>
									</div>

									<div class="row">
										<div class="col">
											<p>
												<strong>LinkedIn</strong><br />
												<a :href="this.appointment.linkedin" target="_blank" v-if="this.appointment.linkedin">View</a>
												<span v-if="!this.appointment.linkedin">N/A</span>
											</p>
										</div>
										<div class="col">
											<p>
												<strong>Website</strong><br />
												<a :href="this.appointment.website" target="_blank" v-if="this.appointment.website">View</a>
												<span v-if="!this.appointment.website">N/A</span>
											</p>
										</div>
									</div>

									<div class="row" v-if="mode === 'appointments'">
										<div class="col">
											<hr />
										</div>
									</div>

									<div class="row" v-if="mode === 'appointments' && this.appointment.type === 'appointment'">
										<div class="col">
											<p>
												<strong>Date of Appointment</strong><br />
												{{ this.appointment.date_of_appointment_clean ?? 'N/A' }}
											</p>
										</div>
									</div>

									<div class="row" v-if="mode === 'appointments'">
										<div class="col">
											<p>
												<strong>Action</strong><br />
												{{ this.appointment.action ?? 'N/A' }}
											</p>
										</div>
									</div>

									<div class="row" v-if="mode === 'appointments'">
										<div class="col">
											<p>
												<strong>Background</strong><br />
												{{ this.appointment.background ?? 'N/A' }}
											</p>
										</div>
									</div>
									
									<div v-if="mode === 'appointments' && this.appointment.reviews.length > 0">
										<div v-for="review in this.appointment.reviews">
											<div class="row">
												<div class="col">
													<hr/>
												</div>
											</div>

											<div class="row">
												<div class="col">
													<div class="form-group">
														<label for="review"><strong>Review</strong></label>
														<div v-for='row in review.review.split("\\n")' class="my-1">
															{{ row }}
														</div>
													</div>

													<div class="form-group">
														<label><strong>Rating</strong></label>

														<div class="d-flex">
															<i class="fa-lg" style="cursor: pointer;"
															   :class="{'far fa-star': review.rating < 1, 'fas fa-star': review.rating >= 1}"></i>
															<i class="fa-lg" style="cursor: pointer;"
															   :class="{'far fa-star': review.rating < 2, 'fas fa-star': review.rating >= 2}"></i>
															<i class="fa-lg" style="cursor: pointer;"
															   :class="{'far fa-star': review.rating < 3, 'fas fa-star': review.rating >= 3}"></i>
															<i class="fa-lg" style="cursor: pointer;"
															   :class="{'far fa-star': review.rating < 4, 'fas fa-star': review.rating >= 4}"></i>
															<i class="fa-lg" style="cursor: pointer;"
															   :class="{'far fa-star': review.rating < 5, 'fas fa-star': review.rating >= 5}"></i>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>

									<div class="row" v-if="mode === 'appointments'">
										<div class="col">
											<hr />
										</div>
									</div>

									<form @submit.prevent="submitFeedback" v-if="mode === 'appointments'">
										<alert v-if="feedbackForm.alert !== null" :type="feedbackForm.alert.type" :message="feedbackForm.alert.message" :errors="feedbackForm.alert.errors"></alert>

										<div class="form-group">
											<label>Feedback</label>
											<textarea 
												class="form-control" 
												rows="5"
												v-model=feedbackForm.data.feedback
											></textarea>
										</div>

										<button 
											class="btn btn-primary" 
											:disabled="feedbackForm.working"
										>
                                        	<i class="fa fa-spin fa-spinner" v-if="feedbackForm.working"></i>
											Submit
										</button>
									</form>
								</div>

								<div class="modal-footer">
									<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	`
});